export default {
  matched: 'Matched',
  other: 'Other',
  associated: 'Associated',
  foundFromServer: 'Found from {appName}',
  recently: 'Recent',
  additionalLabelAccount: 'Account: {displayName}',
  additionalLabelContact: 'Contact: {displayName}',
  notFound: 'N/A',
} as const;
